module.exports = __webpack_public_path__ + "img/first-med1.67920028.png";